package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.ccab.db.ReviewedTestTranscriptData
import com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components.TranscriptWordIndex
import com.neurobs.react.ContextBase

class CommandRouter {
	var setTranscriptTextHighlightedWord: Option[TranscriptWordIndex] => Unit = { _ => Unit }

	var updateSelectionList: ReviewedTestTranscriptData => Unit = { _ => Unit }
}

object CommandRouterContext extends ContextBase[CommandRouter] {
	override protected def defaultStateValue() = new CommandRouter
}